<template>
    <div class="flex pb-4">
        <div class="flex flex-col">
            <div
                    v-on:click="$emit('active')"
                    class="cursor-pointer relative rounded-full bg-grey-light flex items-center justify-center w-8 h-8 text-white"
                    v-bind:class="{'bg-blue-dark':active}"
            >
                <slot name="number"></slot>
            </div>
            <div v-show="!last" class="mt-4 bg-grey-light w-px flex-1 mx-auto " style="min-height: 1vh;"></div>
        </div>
        <div class="pl-4 w-full">
            <div
                    class="cursor-pointer h-8 flex items-center mb-4"
                    v-on:click="$emit('active')"
                    :class="{'text-grey': !active}"
            >
                <slot name="headline"></slot>
            </div>
            <slot v-if="active"></slot>
            <slot class="cursor-pointer" v-on:click="$emit('active')" v-if="!active" name="inactive"></slot>
        </div>
    </div>
</template>

<script>

    export default {

        props: ['active', 'last'],

    }

</script>
